import ApiServiceBase from "@/services/api/apiServiceBase";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {normalizePaginated} from "@/services/api/normalizeProfile";

export class SearchService extends ApiServiceBase {

    public async users(
        query: string,
        opts: {
            page?: number;
            limit?: number;
            lat?: number;
            lng?: number;
            accountType?: string;
            forGroupChatInvite?: boolean;
        } = {},
    ): Promise<UserBasicInformationInterface[]> {
        const payload = await this.http?.get('/users', {
            query,
            page: opts.page ?? 1,
            limit: opts.limit ?? 20,
            ...(opts.lat != null ? {lat: opts.lat} : {}),
            ...(opts.lng != null ? {lng: opts.lng} : {}),
            ...(opts.accountType ? {accountType: opts.accountType} : {}),
            ...(opts.forGroupChatInvite ? {forGroupChatInvite: true} : {}),
        });
        return normalizePaginated(payload).data as UserBasicInformationInterface[];
    }

    public async chatUsers(query: string): Promise<UserBasicInformationInterface[]> {
        return this.users(query, {forGroupChatInvite: true});
    }

    public async tags(tag: string, page = 1): Promise<any> {
        if (!tag) {
            return this.http?.get('/feeds/trending-tags', {limit: 10, days: 7});
        }
        return this.http?.post('/feeds/by-tags', {tagQuery: tag, page, limit: 20});
    }

    public async nearby(
        lat: number,
        lng: number,
        radius = 20,
        type?: string,
    ): Promise<UserBasicInformationInterface[]> {
        const payload = await this.http?.get('/users/available', {
            lat,
            lng,
            radius,
            ...(type ? {accountType: type} : {}),
        });
        return normalizePaginated(payload).data as UserBasicInformationInterface[];
    }

    public async available(
        lat: number,
        lng: number,
        radius = 100,
    ): Promise<UserBasicInformationInterface[]> {
        return this.nearby(lat, lng, radius);
    }
}
